import { render, staticRenderFns } from "./course-score-table.vue?vue&type=template&id=726325a6"
import script from "./course-score-table.vue?vue&type=script&lang=js"
export * from "./course-score-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports